import type { TFunction } from "i18next";
import { OutcomeTypePrefix } from "../../core/api/use-get-tax-payers/FulfilmentDTO";

// TODO: aggiungere mapping per le altre forniture, e gestire nomenclatura comune
const OUTCOME_TYPE_TRANSLATION: Record<string, OutcomeTypePrefix[]> = {
    "ui.utils.outcome_types.outcome.base": [
        OutcomeTypePrefix.F24,
        OutcomeTypePrefix.IVP,
        OutcomeTypePrefix.CIR,
        OutcomeTypePrefix.RLI,
    ],
    "ui.utils.outcome_types.outcome.payment.base": [OutcomeTypePrefix.I24],
    "ui.utils.outcome_types.outcome.suspension.base": [OutcomeTypePrefix.G24],
    "ui.utils.outcome_types.outcome.first_outcome.base": [
        OutcomeTypePrefix.CLR,
    ],
    "ui.utils.outcome_types.outcome.second_outcome.base": [
        OutcomeTypePrefix.CMR,
    ],
};

type ActionType = "download" | "preview";

export const getTranslation = (
    outcomeType: string,
    action: ActionType,
    t: TFunction,
) => {
    return t(getTranslationKey(outcomeType), {
        action:
            action === "download"
                ? t("ui.utils.outcome_types.outcome.outcome.download")
                : t("ui.utils.outcome_types.outcome.outcome.preview"),
    });
};

export const getSummaryTranslation = (outcomeType: string, t: TFunction) => {
    return t(getTranslationKey(outcomeType), {
        action: t("ui.utils.outcome_types.outcome.outcome_summary.download"),
    });
};

export const groupOutcomeTypes = (outcomeTypes: string[]) => {
    return outcomeTypes.reduce((accumulator: string[], current: string) => {
        const outcomeGroup = current.substring(0, 3);
        if (!accumulator.includes(outcomeGroup)) accumulator.push(outcomeGroup);
        return accumulator;
    }, []);
};

const getTranslationKey = (outcomeType: string) => {
    const outcomeTypePrefix = (
        outcomeType.length === 3 ? outcomeType : outcomeType.substring(0, 3)
    ) as OutcomeTypePrefix;

    let translationKey = "";
    Object.keys(OUTCOME_TYPE_TRANSLATION).forEach((key) => {
        if (OUTCOME_TYPE_TRANSLATION[key].includes(outcomeTypePrefix))
            translationKey = key;
    });

    return translationKey;
};
